/* Ease Seating Systems: Early Black Friday cover PDP (multi-section)
   The main section ([data-eb-main]) holds the real product form and the
   variant data (<script type="application/json" data-eb-config>).
   Any other section can drive it with:
     data-eb-pick="color|Royal Purple"            select an option (";" for several)
     data-eb-noscroll                              ...without scrolling to the buy box
     data-eb-current="size|Small 16x16x3"          gets .is-current when that option is selected
     data-eb-follow-img                            <img> that follows the selected variant image
     data-eb-label="color|size|style"              text that shows the selected value
     data-eb-add                                   add the selected variant to the cart
     data-eb-sizeguide                             open the size guide drawer
   Prices always come from Shopify variant data, never computed here. */
(function () {
  'use strict';
  var EB = window.EaseBF = window.EaseBF || {};
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  function setText(sel, txt) { $$(sel).forEach(function (n) { n.textContent = txt; }); }
  var FALLBACK = '$' + '{' + '{amount}' + '}';
  var KEYS = ['size', 'style', 'color'];

  function init() {
    var root = $('[data-eb-main]');
    if (!root || root.getAttribute('data-eb-init') === '1') return;
    root.setAttribute('data-eb-init', '1');
    var cfgEl = $('script[data-eb-config]', root);
    if (!cfgEl) return;
    var C = JSON.parse(cfgEl.textContent);
    var IDX = C.optionIndex || { size: 0, style: 1, color: 2 };

    function money(cents) {
      var f = String(C.moneyFormat || FALLBACK).replace(/<[^>]*>/g, '');
      var re = /\{\{\s*(\w+)\s*\}\}/, m = f.match(re);
      function n(v, p, t, d) { var a = (v / 100).toFixed(p).split('.'); return a[0].replace(/\B(?=(\d{3})+(?!\d))/g, t) + (a[1] ? d + a[1] : ''); }
      var k = m ? m[1] : 'amount', v;
      if (k === 'amount_no_decimals') v = n(cents, 0, ',', '.');
      else if (k === 'amount_with_comma_separator') v = n(cents, 2, '.', ',');
      else if (k === 'amount_no_decimals_with_comma_separator') v = n(cents, 0, '.', ',');
      else v = n(cents, 2, ',', '.');
      return m ? f.replace(re, v) : '$' + v;
    }
    function pct(v) { return v.compare > v.price ? Math.round((v.compare - v.price) / v.compare * 100) : 0; }
    function inputs(k) { return $$('input[name="eb-' + k + '"]', root); }
    function sel() { var o = {}; KEYS.forEach(function (k) { var c = inputs(k).filter(function (i) { return i.checked; })[0]; o[k] = c ? c.value : null; }); return o; }
    function match(o) {
      return C.variants.filter(function (v) {
        return KEYS.every(function (k) { return IDX[k] < 0 || o[k] == null || v.options[IDX[k]] === o[k]; });
      })[0] || null;
    }

    /* ---------- gallery ---------- */
    var stage = $('[data-eb-stage]', root), items = $$('[data-eb-item]', root), thumbs = $$('[data-eb-thumb]', root), gi = 0;
    function mark() {
      thumbs.forEach(function (t, i) { t.setAttribute('aria-current', i === gi ? 'true' : 'false'); });
      setText('[data-eb-count]', (gi + 1) + ' / ' + items.length);
      $$('[data-eb-dots] span', root).forEach(function (d, i) { d.classList.toggle('is-on', i === gi); });
    }
    function goTo(i, instant) {
      if (!items.length || !stage) return;
      gi = (i + items.length) % items.length;
      stage.scrollTo({ left: stage.clientWidth * gi, behavior: instant || reduce ? 'auto' : 'smooth' });
      mark();
    }
    var dots = $('[data-eb-dots]', root);
    if (dots && items.length > 1) dots.innerHTML = items.map(function () { return '<span></span>'; }).join('');
    if (stage) {
      var st;
      stage.addEventListener('scroll', function () {
        clearTimeout(st);
        st = setTimeout(function () { var i = Math.round(stage.scrollLeft / Math.max(1, stage.clientWidth)); if (i !== gi) { gi = i; mark(); } }, 60);
      }, { passive: true });
      thumbs.forEach(function (t, i) { t.addEventListener('click', function () { goTo(i); }); });
      var pv = $('[data-eb-prev]', root), nx = $('[data-eb-next]', root);
      if (pv) pv.addEventListener('click', function () { goTo(gi - 1); });
      if (nx) nx.addEventListener('click', function () { goTo(gi + 1); });
      stage.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(gi - 1); }
        if (e.key === 'ArrowRight') { e.preventDefault(); goTo(gi + 1); }
      });
      window.addEventListener('resize', function () { goTo(gi, true); });
      mark();
    }
    function itemFor(key) { return items.filter(function (x) { return x.getAttribute('data-eb-media') === String(key); })[0]; }
    function srcOf(it) { var im = it && it.querySelector('img'); return im ? (im.currentSrc || im.src) : ''; }

    /* lightbox */
    var lb = $('#eb-lightbox', root), li = 0;
    function lbShow() {
      var it = items[li], im = lb.querySelector('img');
      im.src = (it && it.getAttribute('data-eb-full')) || srcOf(it);
      var a = it && it.querySelector('img'); im.alt = a ? a.alt : '';
      lb.querySelector('[data-lb-count]').textContent = (li + 1) + ' / ' + items.length;
    }
    if (lb && items.length) {
      var z = $('[data-eb-zoom]', root);
      if (z) z.addEventListener('click', function () { li = gi; lbShow(); lb.showModal(); });
      lb.querySelector('[data-lb-prev]').addEventListener('click', function () { li = (li - 1 + items.length) % items.length; lbShow(); });
      lb.querySelector('[data-lb-next]').addEventListener('click', function () { li = (li + 1) % items.length; lbShow(); });
      lb.querySelector('[data-lb-close]').addEventListener('click', function () { lb.close(); });
      lb.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { li = (li - 1 + items.length) % items.length; lbShow(); }
        if (e.key === 'ArrowRight') { li = (li + 1) % items.length; lbShow(); }
      });
      lb.addEventListener('click', function (e) { if (e.target === lb || e.target.classList.contains('eb-lb__stage')) lb.close(); });
      lb.addEventListener('close', function () { goTo(li, true); });
    }
    $$('dialog', root).forEach(function (d) {
      if (d === lb) return;
      d.addEventListener('click', function (e) { if (e.target === d) d.close(); });
    });

    /* ---------- variant state ---------- */
    var idInput = $('[data-eb-variant-id]', root), atc = $('[data-eb-atc]', root), status = $('[data-eb-status]', root), qty = $('[data-eb-qty]', root);
    var current = null;
    function qtyVal() { return Math.max(1, Math.min(99, parseInt(qty && qty.value, 10) || 1)); }

    function availability(o) {
      KEYS.forEach(function (k) {
        inputs(k).forEach(function (inp) {
          var t = {}; KEYS.forEach(function (kk) { t[kk] = kk === k ? inp.value : o[kk]; });
          var v = match(t);
          inp.disabled = !v || !v.available;
        });
      });
      $$('[data-eb-current]').forEach(function (el) {
        var p = el.getAttribute('data-eb-current').split('|'), k = p[0], val = p.slice(1).join('|');
        var t = {}; KEYS.forEach(function (kk) { t[kk] = kk === k ? val : o[kk]; });
        var v = match(t);
        el.classList.toggle('is-unavailable', !v || !v.available);
      });
    }

    function update(push) {
      var o = sel(), v = match(o);
      current = v;
      availability(o);
      KEYS.forEach(function (k) { setText('[data-eb-label="' + k + '"]', o[k] || ''); });
      $$('[data-eb-current]').forEach(function (el) {
        var p = el.getAttribute('data-eb-current').split('|');
        var on = o[p[0]] === p.slice(1).join('|');
        el.classList.toggle('is-current', on);
        el.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      $$('[data-eb-style-card]', root).forEach(function (card) {
        var t = { size: o.size, color: o.color, style: card.getAttribute('data-eb-style-card') };
        var sv = match(t); if (!sv) return;
        $$('[data-eb-sc="now"]', card).forEach(function (n) { n.textContent = money(sv.price); });
        $$('[data-eb-sc="was"]', card).forEach(function (n) { n.textContent = sv.compare > sv.price ? money(sv.compare) : ''; });
        $$('[data-eb-sc="pct"]', card).forEach(function (n) { n.textContent = pct(sv) ? pct(sv) + '% off' : ''; n.hidden = !pct(sv); });
      });
      if (!v) {
        if (atc) atc.disabled = true;
        setText('[data-eb-atc-label]', 'Unavailable'); setText('[data-eb-atc-price]', '');
        $$('[data-eb-add]').forEach(function (b) { b.disabled = true; });
        return;
      }
      var p = pct(v);
      setText('[data-eb-price]', money(v.price));
      setText('[data-eb-compare]', v.compare > v.price ? money(v.compare) : '');
      $$('[data-eb-save]').forEach(function (n) { n.textContent = v.compare > v.price ? 'Save ' + money(v.compare - v.price) + ' (' + p + '% off)' : ''; n.hidden = !(v.compare > v.price); });
      setText('[data-eb-pct]', p ? p + '% off' : '');
      $$('[data-eb-pct-wrap]').forEach(function (n) { n.hidden = !p; });
      setText('[data-eb-variant-title]', KEYS.map(function (k) { return IDX[k] >= 0 ? o[k] : null; }).filter(Boolean).join(', '));
      if (idInput) idInput.value = v.id || '';
      if (atc) atc.disabled = !v.available;
      setText('[data-eb-atc-label]', v.available ? (C.addLabel || 'Add to cart') : (C.soldOutLabel || 'Sold out'));
      setText('[data-eb-atc-price]', v.available ? money(v.price * qtyVal()) : '');
      $$('[data-eb-add]').forEach(function (b) { b.disabled = !v.available; var l = b.querySelector('[data-eb-add-label]') || b; l.textContent = v.available ? (C.addLabel || 'Add to cart') : (C.soldOutLabel || 'Sold out'); });
      $$('[data-eb-color-dot]').forEach(function (d) {
        var s = $$('[data-eb-current]').filter(function (x) { return x.getAttribute('data-eb-current') === 'color|' + o.color && x.style.getPropertyValue('--c'); })[0];
        if (s) d.style.background = s.style.getPropertyValue('--c');
      });
      var it = v.media != null ? itemFor(v.media) : null, src = srcOf(it);
      if (src) {
        $$('[data-eb-follow-img]').forEach(function (f) { f.src = src; f.removeAttribute('srcset'); });
        var si = $('[data-eb-sticky-img]', root); if (si) { si.src = src; si.removeAttribute('srcset'); }
      }
      if (push && it) goTo(items.indexOf(it));
      if (status) { status.textContent = ''; status.className = 'eb-status'; }
      if (push && !C.preview && v.id && history.replaceState) {
        try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u.toString()); } catch (e) {}
      }
      document.dispatchEvent(new CustomEvent('eb:variant-change', { detail: { variant: v } }));
    }
    KEYS.forEach(function (k) { inputs(k).forEach(function (i) { i.addEventListener('change', function () { update(true); }); }); });

    $$('[data-eb-step]', root).forEach(function (b) {
      b.addEventListener('click', function () { qty.value = Math.max(1, Math.min(99, qtyVal() + parseInt(b.getAttribute('data-eb-step'), 10))); update(false); });
    });
    if (qty) qty.addEventListener('change', function () { qty.value = qtyVal(); update(false); });

    /* ---------- add to cart ---------- */
    var added = $('#eb-added', root);
    function refreshCount() {
      if (C.preview) {
        $$('[data-cart-count]').forEach(function (n) { n.textContent = String((parseInt(n.textContent, 10) || 0) + qtyVal()); n.hidden = false; });
        return;
      }
      fetch((C.cartUrl || '/cart') + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { $$('[data-cart-count], .cart-count-bubble span[aria-hidden]').forEach(function (n) { n.textContent = c.item_count; n.hidden = !c.item_count; }); })
        .catch(function () {});
    }
    function showAdded(v, q) {
      if (!added) return;
      var src = srcOf(itemFor(v.media));
      var ai = added.querySelector('[data-added-img]'); if (src) ai.src = src;
      added.querySelector('[data-added-variant]').textContent = KEYS.map(function (k) { return IDX[k] >= 0 ? v.options[IDX[k]] : null; }).filter(Boolean).join(', ') + (q > 1 ? ', qty ' + q : '');
      added.querySelector('[data-added-price]').textContent = money(v.price * q);
      added.showModal();
    }
    function addToCart() {
      var v = current;
      if (!v || !v.available) return;
      var q = qtyVal();
      var busy = [atc].concat($$('[data-eb-add]'), $$('[data-eb-sticky-atc]', root)).filter(Boolean);
      busy.forEach(function (b) { b.classList.add('is-loading'); b.setAttribute('aria-busy', 'true'); });
      if (status) { status.textContent = ''; status.className = 'eb-status'; }
      var req = C.preview
        ? new Promise(function (res) { setTimeout(function () { res({ ok: true, json: function () { return Promise.resolve({}); } }); }, 600); })
        : fetch((C.cartAddUrl || '/cart/add') + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: v.id, quantity: q }] }) });
      req.then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error((res.body && (res.body.description || res.body.message)) || '');
          try { (window.dataLayer = window.dataLayer || []).push({ event: 'eb_cover_add_to_cart', variant_id: v.id, quantity: q, value: v.price * q / 100 }); } catch (e) {}
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('eb:added', { detail: { variant: v, quantity: q } }));
          if (!C.preview && C.afterAdd === 'cart') { location.href = C.cartUrl || '/cart'; return; }
          refreshCount();
          showAdded(v, q);
        })
        .catch(function (err) {
          if (status) { status.className = 'eb-status is-error'; status.textContent = (err && err.message) || 'This cover couldn’t be added. Try a smaller quantity or another option.'; }
        })
        .then(function () { busy.forEach(function (b) { b.classList.remove('is-loading'); b.removeAttribute('aria-busy'); }); });
    }
    var form = $('[data-eb-form]', root);
    if (form) form.addEventListener('submit', function (e) { e.preventDefault(); addToCart(); });
    $$('[data-eb-sticky-atc]', root).forEach(function (b) { b.addEventListener('click', addToCart); });

    /* ---------- pick + size guide (used by other sections) ---------- */
    function pick(key, val, scroll) {
      var inp = inputs(key).filter(function (i) { return i.value === val; })[0];
      if (inp && !inp.disabled) { inp.checked = true; update(true); }
      if (scroll) {
        var box = $('#eb-buy', root);
        if (box) box.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
        if (inp) setTimeout(function () { inp.focus({ preventScroll: true }); }, reduce ? 0 : 600);
      }
    }
    var sg = $('#eb-sizeguide', root);
    function openGuide() {
      if (!sg) return;
      var s = sel().size;
      $$('tbody tr', sg).forEach(function (tr) { tr.classList.toggle('is-current', tr.getAttribute('data-size') === s); });
      sg.showModal();
    }

    /* ---------- sticky bar ---------- */
    var sticky = $('[data-eb-sticky]', root), spacer = $('[data-eb-sticky-spacer]', root);
    if (sticky && atc && 'IntersectionObserver' in window) {
      var off = false, endIn = false;
      var sync = function () {
        var on = off && !endIn;
        sticky.classList.toggle('is-on', on);
        sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
        $$('button', sticky).forEach(function (b) { b.tabIndex = on ? 0 : -1; });
        if (spacer) spacer.classList.toggle('is-on', on);
      };
      new IntersectionObserver(function (en) { en.forEach(function (x) { off = !x.isIntersecting; }); sync(); }).observe(atc);
      var fin = $('[data-eb-final]');
      if (fin) new IntersectionObserver(function (en) { en.forEach(function (x) { endIn = x.isIntersecting; }); sync(); }).observe(fin);
    }

    EB.pick = pick; EB.add = addToCart; EB.openGuide = openGuide; EB.refresh = function () { update(false); };

    /* initial state (honours ?variant=) */
    var want = null; try { want = new URL(location.href).searchParams.get('variant'); } catch (e) {}
    var v0 = want && C.variants.filter(function (x) { return String(x.id) === want; })[0];
    if (!v0) v0 = C.variants.filter(function (x) { return x.id === C.initialId; })[0];
    if (v0) KEYS.forEach(function (k) { if (IDX[k] >= 0) inputs(k).forEach(function (i) { i.checked = i.value === v0.options[IDX[k]]; }); });
    update(false);
    if (want && current && current.media != null) { var it0 = itemFor(current.media); if (it0) goTo(items.indexOf(it0), true); }
  }

  if (!EB.bound) {
    EB.bound = true;
    document.addEventListener('click', function (e) {
      var t = e.target;
      var close = t.closest('[data-dialog-close]');
      if (close) { var d = close.closest('dialog'); if (d) { d.close(); if (close.tagName === 'A' && close.getAttribute('href') === '#') e.preventDefault(); } return; }
      var g = t.closest('[data-eb-sizeguide]');
      if (g) { e.preventDefault(); if (EB.openGuide) EB.openGuide(); return; }
      var a = t.closest('[data-eb-add]');
      if (a) { e.preventDefault(); if (EB.add) EB.add(); return; }
      var size = t.closest('[data-eb-size-pick]');
      if (size) { if (EB.pick) EB.pick('size', size.getAttribute('data-eb-size-pick'), false); var dd = size.closest('dialog'); if (dd) dd.close(); return; }
      var b = t.closest('[data-eb-pick]');
      if (b && EB.pick) {
        e.preventDefault();
        var list = b.getAttribute('data-eb-pick').split(';');
        list.forEach(function (one, i) {
          var p = one.split('|');
          EB.pick(p[0], p.slice(1).join('|'), i === list.length - 1 && !b.hasAttribute('data-eb-noscroll'));
        });
      }
    });
    document.addEventListener('shopify:section:load', function () { init(); if (EB.refresh) EB.refresh(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
